export default __webpack_public_path__ + "static/hw_binary-73d3f1392df55adf554fe983136b23cf.jpg";